import { cn } from "@/lib/utils";

const gradeColors = {
  A: { bg: "bg-emerald-100", text: "text-emerald-700", border: "border-emerald-200" },
  B: { bg: "bg-lime-100", text: "text-lime-700", border: "border-lime-200" },
  C: { bg: "bg-yellow-100", text: "text-yellow-700", border: "border-yellow-200" },
  D: { bg: "bg-orange-100", text: "text-orange-700", border: "border-orange-200" },
  F: { bg: "bg-red-100", text: "text-red-700", border: "border-red-200" }
};

const sizes = {
  xs: "w-6 h-6 text-xs",
  sm: "w-8 h-8 text-sm",
  md: "w-12 h-12 text-lg",
  lg: "w-16 h-16 text-2xl"
};

export const GradeCard = ({ grade, size = "md", className }) => {
  const colors = gradeColors[grade] || gradeColors.F;
  
  return (
    <div
      className={cn(
        "rounded-lg flex items-center justify-center font-bold font-['Outfit'] border",
        colors.bg,
        colors.text,
        colors.border,
        sizes[size],
        className
      )}
      data-testid={`grade-badge-${grade}`}
    >
      {grade}
    </div>
  );
};

export default GradeCard;
